import { render } from "./addProject.vue?vue&type=template&id=828f4cc8"
import script from "./addProject.vue?vue&type=script&lang=js"
export * from "./addProject.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__